import { UploadFile } from 'antd';
import ImageWebsiteLogo, { ColorScheme } from './ImageWebsiteLogo';
import ISerializable from '../../../../lib/ISerializable';

export default class UploadedWebsiteLogo
  extends ImageWebsiteLogo
  implements ISerializable
{
  private fileName: string;

  private fileUid: string;

  private fileObjectURL: string;

  private filePresignedUrl: string;

  constructor(
    // @TODO - think about storing only the file information like id, uuid, and ObjectURL
    private file: UploadFile,
    private colors: ColorScheme,
    private dimensions: {
      width: number;
      height: number;
    }
  ) {
    super();

    this.fileName = this.file.name;
    this.fileUid = this.file.uid;
    this.fileObjectURL = (this.file as any)?.__data__?.data?.data?.ObjectURL;
    this.filePresignedUrl = (
      this.file as any
    )?.__data__?.data?.data?.PresignedUrl;
  }

  public getImageSrc(): string {
    return this.filePresignedUrl;
  }

  public getFileUrl(): string {
    return this.fileObjectURL;
  }

  public getId(): string {
    return this.fileUid;
  }

  public getAltText(): string {
    return this.fileName;
  }

  public getColors(): ColorScheme {
    return this.colors;
  }

  public getDimensions() {
    return this.dimensions;
  }

  public serialize() {
    return JSON.stringify({
      value: {
        file: {
          name: this.fileName,
          uid: this.fileUid,
          __data__: {
            data: {
              data: {
                ObjectURL: this.fileObjectURL,
                PresignedUrl: this.filePresignedUrl
              }
            }
          }
        },
        colors: this.colors,
        dimensions: this.dimensions
      },
      //url: this.url,
      objectType: 'UploadedWebsiteLogo'
    });
  }

  public deserialize(data: any) {
    let _data = JSON.parse(data);
    return new UploadedWebsiteLogo(_data.file, _data.colors, _data.dimensions);
  }
}
